/*
 * ttg-tasse.js — Tassen-Vorschau „zwei Seiten mit Rundung“ (Schema v1.27, 14.10.2026).
 *
 * EIGENSTÄNDIGES Modul neben der Engine (CLAUDE.md §3: Feature-Code in eigene Assets), Muster
 * ttg-foto.js. Die Section lädt die Datei nur, wenn die Config print.vorschau.art === 'tasse'
 * (Blatt-Vertrag) oder photo.blatt.vorschau.art === 'tasse' (Foto-Tassen, Dosen-Vertrag) trägt. Die Engine ruft über ihre Naht (_tasseNaht) window.TTG_TASSE.planen(engine) bei jedem
 * renderPreview und window.TTG_TASSE.snapshot(engine, info) für das Warenkorbbild. Lädt das Modul
 * erst nach der Engine, hat die Engine sich in window.__ttgTasseWartet vorgemerkt — beim Laden
 * werden diese Engines einmal gezeichnet.
 *
 * Fachlich (Prototyp _ablage/creatives/tassen-vorschau-prototyp, freigegeben):
 *  - Seite 1 = Blanko wie geliefert (Henkel rechts) → RECHTE Blatthälfte; Seite 2 = Blanko
 *    gespiegelt (Henkel links) → LINKE Blatthälfte (Naht am Henkel, Vorlage 1005652).
 *  - Doppeldruck ('doppel', Standard): linke Hälfte rechts wiederholt wie der Renderer;
 *    'rundum' und 'zwei-haelften' (Fototasse) zeigen die zwei Hälften des Blatts.
 *  - Spalte u zeigt den Bogen s(u) = r · asin((u − cx) / r_px); Randabdunklung (Lambert,
 *    höchstens randabdunklung, Standard 0,15) nur auf Druckfarbe — Weiß wird nicht gedruckt.
 *  - Warenkorbbild 1000 × 1000: links Seite 2, rechts Seite 1 (Henkel nach außen).
 *
 * Das flache Druckblatt zeichnet die Engine selbst (_renderSnapshot mit opts.ohneBasis) —
 * dieselben Zeichenwege wie das bisherige Warenkorbbild; hier wird nur gebogen.
 */
(function () {
  'use strict';

  /** Flaches Druckblatt (nur Druckinhalt) in pxMm Pixel je mm. live = Live-Vorschau (nicht Warenkorbbild). */
  async function blatt(engine, pxMm, info, live) {
    var q = engine._tasseQuelle(), b = q.blatt, v = q.vorschau;
    var W = Math.max(50, Math.round(b.buehneBreiteMm * pxMm));
    // Foto-Tassen: Foto in der Vorschau nur innerhalb der Druckmaske der Ankerebene (Herz/Oval)
    var pb = engine.config.photo && engine.config.photo.blatt, fotoMaske = null;
    if (pb && pb.originLayer) {
      var pp = engine._decoLayers().find(function (l) { return l.id === pb.originLayer; });
      if (pp && pp.druckMaske) fotoMaske = { url: pp.druckMaske, layer: pp };
    }
    // Beispielfoto (Schema v1.28, Opt-in vorschau.beispielFoto: true): vor dem Upload config.photo.sampleUrl im
    // Herz/Oval — NUR in der Live-Vorschau, nie im Warenkorbbild (snapshot ruft blatt ohne live).
    var bsp = (live && v.beispielFoto === true && pb && engine.config.photo.sampleUrl && !(engine.state.photo && engine.state.photo.crop)) ? engine.config.photo.sampleUrl : null;
    var buehne = await engine._renderSnapshot(info || null, { ohneBasis: true, W: W, maxSeite: pxMm <= 4 ? 1600 : 0, fotoMaske: fotoMaske, beispielFoto: bsp });
    if (!buehne) return null;
    var bw = Math.round(b.breiteMm * pxMm), bh = Math.round(b.hoeheMm * pxMm);
    var c = document.createElement('canvas'); c.width = bw; c.height = bh;
    var x = c.getContext('2d');
    x.fillStyle = '#ffffff'; x.fillRect(0, 0, bw, bh);
    x.drawImage(buehne, Math.round(((b.xPercent || 0) / 100) * W), Math.round(((b.yPercent || 0) / 100) * W), bw, bh, 0, 0, bw, bh);
    if ((v.seiten || 'doppel') === 'doppel') {
      var dx = Math.round(bw / 2);
      x.drawImage(c, 0, 0, dx, bh, dx, 0, bw - dx, bh);
    }
    // Fototasse: der Renderer kopiert jede Textzeile um dxMm (Name einmal eingeben, zweimal gedruckt).
    // Die Vorschau kopiert das Textfenster (frei von Motiv-Tinte) multiplizierend an dieselbe Stelle.
    var tk = v.textKopie;
    if (tk && tk.dxMm) {
      x.globalCompositeOperation = 'multiply';
      x.drawImage(c, tk.xMm * pxMm, tk.yMm * pxMm, tk.wMm * pxMm, tk.hMm * pxMm, (tk.xMm + tk.dxMm) * pxMm, tk.yMm * pxMm, tk.wMm * pxMm, tk.hMm * pxMm);
      x.globalCompositeOperation = 'source-over';
    }
    return c;
  }

  /** Geometrie einer Tassenseite in einem N × N-Canvas (Körper, Zylinder, Band) — gemeinsam für Zeichnen und Foto-Griff. */
  function geometrie(engine, N, nr) {
    var q = engine._tasseQuelle(), v = q.vorschau, b = q.blatt;
    var k = v.koerper || {};
    var L = (k.links || 0) * N, R = (k.rechts != null ? k.rechts : 1) * N;
    if (nr === 2) { var l0 = L; L = N - R; R = N - l0; }
    var O = (k.oben || 0) * N, U = (k.unten != null ? k.unten : 1) * N;
    var D = v.durchmesserMm || 80, rmm = D / 2, rpx = (R - L) / 2, cx = (L + R) / 2, kk = (R - L) / D;
    var halb = b.breiteMm / 2, xc = (nr === 1 ? halb : 0) + halb / 2, smax = halb / 2;
    var umax = rpx * Math.sin(Math.min(smax / rmm, Math.PI / 2)), bandH = b.hoeheMm * kk, top = (O + U) / 2 - bandH / 2;
    return { rmm: rmm, rpx: rpx, cx: cx, kk: kk, halb: halb, xc: xc, smax: smax, umax: umax, bandH: bandH, top: top };
  }

  /** Eine Tassenseite in den Ziel-Canvas: Blanko (Seite 2 gespiegelt), Blatthälfte zylindrisch gebogen. */
  function seite(engine, ziel, bl, blanko, nr) {
    var q = engine._tasseQuelle(), v = q.vorschau, b = q.blatt;
    var N = ziel.width, x = ziel.getContext('2d');
    x.setTransform(1, 0, 0, 1, 0, 0); x.globalCompositeOperation = 'source-over';
    x.fillStyle = '#ffffff'; x.fillRect(0, 0, N, N);
    x.save(); if (nr === 2) { x.translate(N, 0); x.scale(-1, 1); } engine._drawContain(x, blanko, { x: 0, y: 0, w: N, h: N }); x.restore();
    var g = geometrie(engine, N, nr);
    var rmm = g.rmm, rpx = g.rpx, cx = g.cx, xc = g.xc, smax = g.smax, umax = g.umax, bandH = g.bandH, top = g.top;
    var u0 = Math.ceil(cx - umax), u1 = Math.floor(cx + umax), bw = Math.max(1, u1 - u0 + 1), bh = Math.max(1, Math.round(bandH));
    var band = document.createElement('canvas'); band.width = bw; band.height = bh;
    var bx = band.getContext('2d');
    var sp = bl.width / b.breiteMm;
    var sArc = function (u) { return rmm * Math.asin(Math.max(-1, Math.min(1, (u - cx) / rpx))); };
    for (var u = u0; u <= u1; u++) {
      var a = sArc(u), e = sArc(u + 1);
      bx.drawImage(bl, (xc + a) * sp, 0, Math.max(1, (e - a) * sp), bl.height, u - u0, 0, 1, bh);
    }
    var dunkel = v.randabdunklung != null ? v.randabdunklung : 0.15;
    if (dunkel > 0) {
      var d = bx.getImageData(0, 0, bw, bh), px = d.data, nenner = 1 - Math.cos(smax / rmm) || 1;
      var fak = new Float32Array(bw);
      for (var i = 0; i < bw; i++) fak[i] = dunkel * (1 - Math.cos(sArc(u0 + i + 0.5) / rmm)) / nenner;
      for (var y = 0; y < bh; y++) for (var j = 0; j < bw; j++) {
        var o = (y * bw + j) * 4, ink = 1 - Math.min(px[o], px[o + 1], px[o + 2]) / 255, g = 1 - fak[j] * ink;
        px[o] *= g; px[o + 1] *= g; px[o + 2] *= g;
      }
      bx.putImageData(d, 0, 0);
    }
    x.globalCompositeOperation = 'multiply'; x.drawImage(band, u0, top); x.globalCompositeOperation = 'source-over';
  }

  /** Live-Vorschau zeichnen: zwei Canvas über der DOM-Vorschau; ältere Läufe verfallen. */
  async function zeichnen(engine) {
    var preview = engine.refs && engine.refs.base && engine.refs.base.parentElement;
    if (!preview) return;
    var box = preview.querySelector('[data-ttg="tasse"]');
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-ttg', 'tasse');
      box.setAttribute('aria-hidden', 'true');
      box.style.cssText = 'position:absolute;inset:0;z-index:6;display:flex;align-items:center;justify-content:center;gap:2%;background:var(--ttg-stage-bg,#ffffff);pointer-events:none';
      box.innerHTML = '<canvas width="600" height="600" style="width:49%;height:auto"></canvas><canvas width="600" height="600" style="width:49%;height:auto"></canvas>';
      preview.appendChild(box);
    }
    // Galerie (14.10.2026): Das große Produktfoto der Bühne (.ttg__stage-photo, z-index 3) und die Blätter-Pfeile (z-index 4)
    // lagen UNTER der Tassen-Vorschau (z-index 6) — ein Klick aufs Vorschaubild schaltete das Foto ein, sichtbar blieb die
    // Live-Tasse. Nur auf Tassen-Bühnen (dieses Modul lädt nur dort) beide darüber heben; die Mini-Vorschau (eigener
    // Wrapper) und alle anderen Produkte bleiben unberührt.
    var stage = preview.closest ? preview.closest('.ttg__stage') : null;
    if (stage && !stage.hasAttribute('data-ttg-tasse-galerie')) {
      stage.setAttribute('data-ttg-tasse-galerie', '');
      var ph = stage.querySelector('[data-ttg-stage-photo]');
      if (ph) ph.style.zIndex = '7';
      var pf = stage.querySelectorAll('[data-ttg-stage-prev],[data-ttg-stage-next]');
      for (var pi = 0; pi < pf.length; pi++) pf[pi].style.zIndex = '8';
    }
    var lauf = (engine._tasseLauf = (engine._tasseLauf || 0) + 1);
    var t0 = (typeof performance !== 'undefined') ? performance.now() : 0;
    var v = engine._tasseQuelle().vorschau;
    var r = await Promise.all([blatt(engine, v.pxMm || 4, null, true), engine._loadImg(v.blanko)]);
    if (lauf !== engine._tasseLauf || !r[0] || !r[1]) return;
    var cs = box.querySelectorAll('canvas');
    seite(engine, cs[0], r[0], r[1], 1);
    seite(engine, cs[1], r[0], r[1], 2);
    // Schild „Beispielfoto“ (nur Live-Vorschau, DOM — nie im Warenkorbbild/Druck): klein, unten rechts am Rand der
    // Vorschau, verdeckt das Motiv nicht. Sichtbar nur, solange das Beispielfoto statt eines Kundenfotos gezeichnet ist.
    var pb = engine.config.photo, beispiel = !!(v.beispielFoto === true && pb && pb.sampleUrl && !(engine.state.photo && engine.state.photo.crop));
    var schild = box.querySelector('[data-ttg="tasse-beispiel"]');
    if (beispiel && !schild) {
      schild = document.createElement('span');
      schild.setAttribute('data-ttg', 'tasse-beispiel');
      schild.style.cssText = 'position:absolute;right:6px;bottom:6px;font:600 11px/1.3 system-ui,sans-serif;color:#555;background:rgba(255,255,255,.88);border:1px solid #ddd;border-radius:4px;padding:2px 6px;pointer-events:none';
      schild.textContent = (pb && pb.sampleLabel) || 'Beispielfoto';   // gleicher Text wie das DOM-Schild (config.photo.sampleLabel)
      box.appendChild(schild);
    }
    if (schild) schild.style.display = beispiel ? '' : 'none';
    griff(engine, preview, box, cs);
    if (typeof performance !== 'undefined') engine._tasseMs = performance.now() - t0;
  }

  /** Foto-Griff (Fototassen, 14.10.2026): Die Foto-Ebene der Engine liegt an ihrer flachen Bühnen-Position unter der
   *  deckenden Tassen-Vorschau — der Kunde sieht sein Foto nur auf der gezeichneten Tasse und konnte es dort nicht
   *  greifen. Über Herz/Oval jeder Tassenseite, auf der das Foto zu sehen ist (Doppeldruck: beide), liegt deshalb eine
   *  unsichtbare Fläche mit den Gesten aus ttg-foto.js (Drag = verschieben, Pinch = zoomen; der Regler bleibt).
   *  Lage: Box der Foto-Ebene auf der Bühne → mm im Druckblatt → Spalte auf dem Zylinder u = cx + r·sin((s − xc)/r),
   *  wie seite() zeichnet. Nur mit eigenem Kundenfoto (state.photo.crop) und geladenem ttg-foto.js; sonst ausgeblendet. */
  function griff(engine, preview, box, cs) {
    var alle = box.querySelectorAll('[data-ttg="tasse-foto-griff"]');
    var aus = function () { for (var i = 0; i < alle.length; i++) alle[i].style.display = 'none'; };
    var foto = engine.refs && engine.refs.photo, F = window.TTG_FOTO;
    if (!(engine.config.photo && engine.state.photo && engine.state.photo.crop && foto && F && typeof F.bindFlaeche === 'function'
      && foto.style.display !== 'none')) return aus();
    var q = engine._tasseQuelle(), b = q.blatt, v = q.vorschau;
    var pr = preview.getBoundingClientRect(), fr = foto.getBoundingClientRect(), br = box.getBoundingClientRect();
    if (!pr.width || !fr.width || !br.width) return aus();
    var mm = b.buehneBreiteMm / pr.width, ox = ((b.xPercent || 0) / 100) * b.buehneBreiteMm, oy = ((b.yPercent || 0) / 100) * b.buehneBreiteMm;
    var s0 = (fr.left - pr.left) * mm - ox, s1 = (fr.right - pr.left) * mm - ox;   // Blatt-x in mm
    var y0 = (fr.top - pr.top) * mm - oy, y1 = (fr.bottom - pr.top) * mm - oy;     // Blatt-y in mm
    var halb = b.breiteMm / 2, lagen = [[s0, s1]];
    // Doppeldruck: die linke Blatthälfte steht rechts noch einmal (blatt()) → Foto auch auf Seite 1
    if ((v.seiten || 'doppel') === 'doppel' && (s0 + s1) / 2 < halb) lagen.push([s0 + halb, s1 + halb]);
    var pz = function (x, ganz) { return (100 * x / ganz).toFixed(3) + '%'; };   // Prozent der Box: wandert bei Größenänderung mit
    var genutzt = {};
    lagen.forEach(function (l) {
      var nr = ((l[0] + l[1]) / 2 >= halb) ? 1 : 2, c = cs[nr - 1];               // Seite 1 = rechte Blatthälfte (erster Canvas)
      var N = c.width, g = geometrie(engine, N, nr), cr = c.getBoundingClientRect(), k = cr.width / N;
      var u = function (sx) { var w = Math.max(-1, Math.min(1, (sx - g.xc) / g.rmm)); return g.cx + g.rpx * Math.sin(Math.max(-Math.PI / 2, Math.min(Math.PI / 2, w))); };
      var x0 = Math.max(g.cx - g.umax, u(l[0])), x1 = Math.min(g.cx + g.umax, u(l[1]));
      if (!(x1 > x0)) return;
      var el = box.querySelector('[data-ttg="tasse-foto-griff"][data-seite="' + nr + '"]');
      if (!el) {
        el = document.createElement('div');
        el.setAttribute('data-ttg', 'tasse-foto-griff');
        el.setAttribute('data-seite', String(nr));
        el.style.cssText = 'position:absolute;pointer-events:auto;touch-action:none;cursor:grab;user-select:none;-webkit-user-select:none';
        box.appendChild(el);
        F.bindFlaeche(engine, el);
      }
      genutzt[nr] = true;
      el.style.display = '';
      el.style.left = pz(cr.left - br.left + x0 * k, br.width);
      el.style.top = pz(cr.top - br.top + (g.top + y0 * g.kk) * k, br.height);
      el.style.width = pz((x1 - x0) * k, br.width);
      el.style.height = pz((y1 - y0) * g.kk * k, br.height);
    });
    alle = box.querySelectorAll('[data-ttg="tasse-foto-griff"]');
    for (var i = 0; i < alle.length; i++) if (!genutzt[alle[i].getAttribute('data-seite')]) alle[i].style.display = 'none';
  }

  var TTG_TASSE = {
    /** Ein Neuzeichnen je Frame planen (Naht aus renderPreview). */
    planen: function (engine) {
      if (!engine._bildCache) engine._bildCache = new Map();
      if (engine._tasseGeplant) return;
      engine._tasseGeplant = true;
      var los = function () {
        engine._tasseGeplant = false;
        zeichnen(engine).catch(function (e) { console.warn('[ttg] Tassen-Vorschau übersprungen:', e && e.message); });
      };
      if (typeof requestAnimationFrame === 'function') requestAnimationFrame(los); else setTimeout(los, 0);
    },
    /** Warenkorbbild 1000 × 1000 (Naht aus _renderSnapshot). */
    snapshot: async function (engine, info) {
      if (!engine._bildCache) engine._bildCache = new Map();
      var v = engine._tasseQuelle().vorschau;
      var r = await Promise.all([blatt(engine, 8, info), engine._loadImg(v.blanko)]);
      if (!r[0] || !r[1]) { if (info && !info.grund) info.grund = r[1] ? 'tasse:blatt' : 'tasse:blanko'; return null; }
      var S = 1000, c = document.createElement('canvas'); c.width = S; c.height = S;
      var x = c.getContext('2d'); x.fillStyle = '#ffffff'; x.fillRect(0, 0, S, S);
      var s = document.createElement('canvas'); s.width = 500; s.height = 500;
      seite(engine, s, r[0], r[1], 2); x.drawImage(s, 0, 250);
      seite(engine, s, r[0], r[1], 1); x.drawImage(s, 500, 250);
      return c;
    },
    blatt: blatt,
    seite: seite,
  };
  window.TTG_TASSE = TTG_TASSE;
  // Engines, die vor dem Modul gerendert haben, einmal nachzeichnen.
  var wartend = window.__ttgTasseWartet;
  if (wartend && wartend.size) { wartend.forEach(function (e) { TTG_TASSE.planen(e); }); wartend.clear(); }
})();
